(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();

  class SlideOutModal extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({ mode: 'open' });
                this.shadowRoot.innerHTML = `
                    <style>
                        :host {
                            position: fixed;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            display: none;
                            z-index: 1000;
                        }

                        .overlay {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            background-color: rgba(0, 0, 0, 0.5);
                            opacity: 0;
                            transition: opacity 0.3s ease-out;
                        }

                        .modal {
                            position: absolute;
                            top: 0;
                            right: -600px;
                            width: 600px;
                            height: 100%;
                            background-color: white;
                            box-shadow: -2px 0 5px rgba(0, 0, 0, 0.3);
                            transition: right 0.3s ease-out;
                            overflow-y: auto;
                            max-width: 96%;
                        }

                        .modal img {
                          max-width: 100%;
                        }

                        :host([open]) {
                            display: block;
                        }

                        :host([open]) .overlay {
                            opacity: 1;
                        }

                        :host([open]) .modal {
                            right: 0;
                        }

                        .modal-content {
                            padding: 20px;
                            opacity: 0;
                            transform: translateX(20px);
                            transition: opacity 0.3s ease-out, transform 0.3s ease-out;
                        }

                        :host([open]) .modal-content {
                            opacity: 1;
                            transform: translateX(0);
                        }

                        .close-btn {
                            position: absolute;
                            top: 16px;
                            right: 16px;
                            font-size: 24px;
                            cursor: pointer;
                            opacity: 0.5;
                        }
                    </style>
                    <div class="overlay"></div>
                    <div class="modal">
                        <div class="modal-content">
                            <span class="close-btn">
                              <img width="32" height="32" src="https://cdn.shopify.com/s/files/1/0703/7190/1665/files/close.svg?v=1723040859"/>
                            </span>
                            <div id="content-container">
                                <slot></slot>
                            </div>
                        </div>
                    </div>
                `;

                this.overlay = this.shadowRoot.querySelector('.overlay');
                this.modal = this.shadowRoot.querySelector('.modal');
                this.modalContent = this.shadowRoot.querySelector('.modal-content');
                this.closeBtn = this.shadowRoot.querySelector('.close-btn');
                this.contentContainer = this.shadowRoot.querySelector('#content-container');

                this.closeBtn.addEventListener('click', () => this.close());
                this.overlay.addEventListener('click', (e) => {
                    if (e.target === this.overlay) {
                        this.close();
                    }
                });
            }

            open() {
                this.style.display = 'block';
                // Force a reflow to ensure the initial state is applied before transitions
                void this.offsetWidth;
                this.setAttribute('open', '');
                document.body.style.overflow = 'hidden';
            }

            close() {
                this.modalContent.style.opacity = '0';
                this.modalContent.style.transform = 'translateX(20px)';
                this.modal.style.right = '-300px';
                this.overlay.style.opacity = '0';

                setTimeout(() => {
                    this.removeAttribute('open');
                    this.style.display = 'none';
                    document.body.style.overflow = '';
                    // Reset styles for next open
                    this.modalContent.style.opacity = '';
                    this.modalContent.style.transform = '';
                    this.modal.style.right = '';
                    this.overlay.style.opacity = '';
                }, 300);
            }

            setContent(content) {
                this.contentContainer.innerHTML = content;
            }
        }
        customElements.define('slide-out-modal', SlideOutModal);
   
})();
